import moment from 'moment'
import { repeatStringForService } from '../../helpers'
import { IClientInfo, IServiceInfo, ITown } from '../../models'
import { IFindResultAvailabilities } from '../../models/find-result-availabilities'
import { BaseHttpService } from './base'

class TownService extends BaseHttpService {
  public getTowns = async (): Promise<ITown[]> => {
    return this.get('towns')
  }

  public getServices = async (townId: number): Promise<IServiceInfo[]> => {
    return this.get(`towns/${townId}/service-infos?mergedStops=true`)
  }

  public getClientInfo = async (townId: number): Promise<IClientInfo> => {
    return this.get(`towns/${townId}/client-info`)
  }

  public getDestinationBusStops = async (
    townId: number,
    stopId: number
  ): Promise<ITown[]> => {
    return this.get(`towns/${townId}/stops-from/${stopId}?mergedStops=true`)
  }

  public getAvailabilitiesAndFailures = async (
    townId: number,
    originStopId: number,
    destinationStopId: number,
    exitSeats: number,
    exitPrmSeats: number,
    date: Date,
    specificDate: boolean,
    alternatives: number,
    onlyToday: boolean,
    id?: string,
  ): Promise<IFindResultAvailabilities> => {
    const exitString = repeatStringForService(
      '',
      destinationStopId,
      exitSeats
    )
  
    let exitPrmSeatsString = ''
    if (exitPrmSeats > 0) {
      exitPrmSeatsString = repeatStringForService(
        '&prm-exit-stops=',
        destinationStopId,
        exitPrmSeats
      )
    }

    let path = `towns/${townId}/v2/availabilities/${originStopId}/${exitString}?date-time=${moment(date).format('YYYYMMDDHHmm')}${exitPrmSeatsString}&arrival-time=${specificDate}`
    
    path += id ? `&reservation-id=${id}` : ''
    path += alternatives ? `&nAlternatives=${alternatives}` : ''
    path += onlyToday ? `&only-today=${onlyToday}` : ''

    return this.get(path)
  }


  public getAvailableDates = async (
    townId: number,
    startDate: Date,
    endDate: Date,
    startStopId?: number,
    endStopId?: number,
    serviceId?: number,
    isSingleStop?: boolean
  ): Promise<any> => {
    let path = 
    `towns/${townId}/available-dates?from=${moment(startDate).format('YYYY-MM-DD HH:mm')}&to=${moment(endDate).format('YYYY-MM-DD HH:mm')}`

    path += serviceId ? `&serviceId=${serviceId}` : ''
    path += startStopId ? `&startStopId=${startStopId}` : ''
    path += endStopId ? `&endStopId=${endStopId}` : ''
    path += isSingleStop ? `&single_stop=${isSingleStop}` : ''

    return this.get(path)
  }
  
  public getServicesTicketingType = async (
    townId: number
  ): Promise<any> => {
    let path = `towns/${townId}/services/ticketing-type`

    return this.get(path)
  }
}

export default new TownService()
